module.exports = __webpack_public_path__ + "img/ru.svg";